
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/[[...slug]]",
      function () {
        return require("private-next-pages/marketplace/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/[[...slug]]"])
      });
    }
  